import {useId} from 'react'
import {cn} from 'utils/cn'
import {GRADIENT_STROKE} from './gold'

// The same Lucide "coins" path that assets/img/coins*.svg carry, drawn
// with a gold gradient stroke instead of a flat colour.
const PATH =
  'M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V6.5M2 5V17C2 18.1046 4.46243 19 7.5 19M7.5 11C7.33145 11 7.16468 10.9972 7 10.9918C4.19675 10.9 2 10.0433 2 9M7.5 15C4.46243 15 2 14.1046 2 13M22 11.5C22 12.6046 19.5376 13.5 16.5 13.5C13.4624 13.5 11 12.6046 11 11.5M22 11.5C22 10.3954 19.5376 9.5 16.5 9.5C13.4624 9.5 11 10.3954 11 11.5M22 11.5V19C22 20.1046 19.5376 21 16.5 21C13.4624 21 11 20.1046 11 19V11.5M22 15.25C22 16.3546 19.5376 17.25 16.5 17.25C13.4624 17.25 11 16.3546 11 15.25'

/**
 * The Sharpenny coin. Decorative by default (`aria-hidden`); pass
 * `title` to make it announce itself.
 */
const CoinIcon = ({className, title, ...props}) => {
  // useId yields ":r1:"; colons are not valid inside url(#…).
  const gradientId = `coin-gold-${useId().replace(/:/g, '')}`
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : 'true'}
      className={cn('w-4 h-4 shrink-0', className)}
      {...props}
    >
      {title && <title>{title}</title>}
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          {GRADIENT_STROKE.map((stop) => (
            <stop
              key={stop.offset}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
      <path
        d={PATH}
        stroke={`url(#${gradientId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CoinIcon
